export const SEARCH_BY_VIN = '[x time schedule service] search by vin';
export const SERVICES_DATA = '[x time schedule service] service data';
export const INCREMENT_STEP = '[x time schedule service] increment step';
export const DECREMENT_STEP = '[x time schedule service] decrement step';
export const VEHICLE_INFO = '[x time schedule service] selected vehicle info';
export const WEB_SERVICE_LOG = '[x time schedule service] web service log';
export const SHOW_LOADING = '[x time schedule service] show loading';
export const IS_SERVICE_PACKAGE_SELECTED = '[x time schedule service] add service op code';
export const SERVICE_PACKAGE_OP_CODE = '[x time schedule service]  service package op code';
export const INDIVIDUAL_OP_CODES = '[x time schedule service] individual op codes';
export const GET_AVAILABLE_SLOTS = '[x time schedule service] get available slots';
export const BOOKING_SLOT_TIME = '[x time schedule service] booking slot time';
export const BOOK_APPOINTMENT_SLOT = '[x time schedule service] book appointment slot';
export const USER_DETAILS = '[x time schedule service] user details';
export const INDIVIDUAL_SERVICE_LIST = '[x time schedule service] individual service list';
export const START_DATE = '[x time schedule service] start date';
export const SHOW_AVAILABLE_SLOTS = '[x time schedule service] show available slots';
export const SELECTED_DATE = '[x time schedule service] selected date';
export const SELECTED_TIME_SLOT = '[x time schedule service] selected time slot';
export const NO_SLOTS_AVAILABLE = '[x time schedule service] no slots available';
export const MONTH_NAMES = '[x time schedule service] month names';
export const SET_SELECTED_DATE = '[x time schedule service] selected date';
export const SLOT_DATE_TIME = '[x time schedule service] slot date time';
export const GET_SLOT_DATE_TIME = '[x time schedule service] get slot date time';
export const SET_CURRENT_STEP = '[x time schedule service] set current step';
export const GET_SERVICE_TYPES = '[x time schedule service] get service types';
export const SET_SERVICE_TYPES = '[x time schedule service] set service types';
export const SET_SELECTED_SERVICE_TYPES = '[x time schedule service] set selected service types';
export const GET_X_TIME_SERVICE_TYPES = '[x time schedule service] get xtime service types';
export const FILTER_SERVICE_OPCODES = '[x time schedule service] filter service opcodes';
export const ALL_FILTERED_SELECTED_SERVICES =
  '[x time schedule service] all filtered selected services';
export const SERVICE_ERROR = '[x time schedule service] service error';
export const SERVICE_COUPONS = '[schedule service] coupons';
export const SELECTED_COUPON_IDS_NAMES = '[schedule service] selected coupon ids and names';
export const SCHEDULE_SERVICE_TYPE = '[schedule service] type';
export const LOGGED_IN_USER_INFO = '[schedule service] logged in user info';
export const EMAIL_PAYLOAD = '[schedule service] schedule email';
export const CALL_EMAIL_API = '[schedule service] call schedule email';
export const LOG_LEAD_API = '[schedule service] call log lead api';
export const LOG_LEAD_PAYLOAD = '[schedule service] log lead payload';
export const GET_SELECTED_SERVICE_PACKAGE_NAME = '[schedule service] selected service package name';
export const GET_VEHICLE_MODEL = '[schedule service] selected vehicle model';
export const GET_CURRENT_COMPONENT_NAME = '[schedule service] get current component name';
export const SERVICE_APPRAISAL = '[schedule service] service appraisal';
export const SERVICE_COMMENTS = '[schedule service] service comments';
export const DISPLAY_SERVICE_NAMES = '[schedule service] display service names';
export const SCHEDULES_SERVICE_SETTINGS = '[schedule service] settings';
export const SET_SERVICE_DATA = '[schedule service] service data';
export const SERVICE_PREFERENCE = '[schedule service] service preference';
export const SELECTED_ADMIN_SERVICE_NAMES = '[schedule service] selected admin service names';
export const SELECTED_VEHICLE = '[schedule service] selected make model';

export const TRANSPORT_TYPE = '[schedule service] transport type';
export const ADVISOR = '[schedule service] selected advisor';
export const SERVICE_COMMENTS_DESCRIBE = '[schedule service] comments describe whats going on';
export const SELECTED_MAKE = '[schedule service] selected make';
export const AVAILABILITY_SERVICE_CALL_COUNT = '[schedule service] availability service call';
export const GET_STEP_NAMES = '[schedule service] step names for non-XTime';
export const X_TIME_SUBMITTED = '[schedule service] schedule service submitted';
export const SELECTED_STYLE = '[schedule service] selected style';
export const SELECTED_SERVICE_COUPONS_OBJECT = '[schedule service] selected service coupons object';
export const SHOW_NEXT_BUTTON = '[schedule service] show next button';
export const GET_TRANSPORT_TYPES = '[schedule service] get transport types';
export const SET_AVAILABILITIES_URL = '[schedule service] set availabilities url';
export const AVAILABILITIES_CALL_TO_CHECK_WAITER =
  '[schedule service] check waiter option is allowed';
export const TRANSPORT_TYPE_ERROR = '[schedule service] check waiter allowed';
export const TRANSPORT_VALET_OPTIONS = '[schedule service] transport valet options';
export const GET_BOOK_APPOINTMENT_REQUEST = '[schedule service] get XTime book appointment request';
export const ADDITIONAL_SERVICE_COMMENTS = '[schedule service] additional service comments';
export const REQUIRED_ADDITIONAL_SERVICE_COMMENTS =
  '[schedule service] required additional service comments';
